import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from '../reducers';
import createSagaMiddleware from 'redux-saga';

/** @see {@link https://github.com/zalmoxisus/redux-devtools-extension}  */
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import rootSaga from '../sagas';
import optimisticUI from './middleware/optimisticUI';

export default function configureStore(initialState) {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    reducer,
    initialState,
    composeWithDevTools(applyMiddleware(optimisticUI, thunk, sagaMiddleware))
  );
  sagaMiddleware.run(rootSaga);
  return store;
}
